module.exports = __webpack_public_path__ + "img/marketingFill.83c7422f.svg";